import React, { useCallback } from 'react';
import { KYCOrganism } from 'Components/ComponentLibrary/Organisms/kycOrganism';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { DialogContent } from 'Views/Page/Content/Modal/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';

export const KYCIntroStepLayout = () => {
  const { setModalCollection, clearModalCollection, modalResource: resource } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const onKYCFinished = useCallback(async ({ externalID }) => {
    resource.attr('externalId', externalID);
    try {
      setModalCollection(await resource.submit());
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  }, [resource]);
  return (
    <>
      <MetaControlField attr="title" />
      <DialogContent>
        <FDStack direction="column" spacing={3}>
          <MetaControlField attr="description" />
          <KYCOrganism resource={resource} onKYCFinished={onKYCFinished} />
          <MetaControlField attr="cancelText" cancel={clearModalCollection} />
        </FDStack>
      </DialogContent>
    </>
  );
};
